import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import BtnLoader from "../components/BtnLoader";
import { useForm } from "react-hook-form";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { LOGN_API } from "../app/constants";
import { BASE_URL } from "..";
import Notification from "../helper/Notification";

const LoginSection = () => {
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMessage, setIsMessage] = useState(null); // Stores message for notification
  const [showNotification, setShowNotification] = useState(false); // Toggle notification visibility

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLoginSuccess = (response) => {
    const credential = response.credential;
    setAccessToken(response.credential); // Save the token for API requests
    // Fetch the phone number using People API
    fetchPhoneNumber(response.credential);
  };

  const fetchPhoneNumber = async (accessToken) => {
    try {
      const response = await fetch(
        "https://people.googleapis.com/v1/people/me?personFields=phoneNumbers",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        console.log("Phone Number Data: ", data);
        if (data.phoneNumbers && data.phoneNumbers.length > 0) {
          setPhoneNumber(data.phoneNumbers[0].value);
        } else {
          setPhoneNumber("No phone number provided");
        }
      } else {
        console.error("Error fetching phone number:", response.statusText);
        setPhoneNumber("Error fetching phone number");
      }
    } catch (error) {
      console.error("Error in fetching phone number:", error);
      setPhoneNumber("Error fetching phone number");
    }
  };

  const handleLoginFailure = () => {
    console.log("Login Failed");
  };

  useEffect(() => {
    console.log("User State: ", user);
  }, [user]);

  const loginUser = async (data) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}${LOGN_API}`, {
        email: data.email,
        password: data.password,
      });

      console.log("Data here:", response.data);

      if (response.status === 200 && response.data.code === 1) {
        sessionStorage.setItem("email", response.data.data.user.email);
        sessionStorage.setItem("name", response.data.data.user.name);
        localStorage.setItem("accessToken", response.data.data.token);
        console.log(response.data);
        navigate("/");
      } else {
        setIsMessage(
          response.data.message || "Something went wrong. Please try again."
        );
        setShowNotification(true);
      }
    } catch (error) {
      console.error("Error occurred:", error);

      if (error.response) {
        // Handle known server responses
        setIsMessage(
          error.response.data?.message ||
            "Server error occurred. Please try again."
        );
      } else if (error.request) {
        // Handle no response case
        setIsMessage(
          "No response from server. Please check your internet connection."
        );
      } else {
        // Handle unexpected errors
        setIsMessage("An unexpected error occurred. Please try again.");
      }

      setShowNotification(true);
    }
    setIsLoading(false);
  };

  return (
    <section className="flex-center bg-light bg-white">
      <Notification
        show={showNotification}
        type="success"
        title="Failed"
        message={isMessage}
        onClose={() => setShowNotification(false)}
      />
      <div
        className="container container-lg flex-center  py-40 "
        // style={{
        //   marginRight: "4rem",
        // }}
      >
        <form onSubmit={handleSubmit(loginUser)} className="flex-center gap-4 ">
          <div className="gy-4 rounded bg-white  d-flex flex-column flex-lg-row gap-10">
            {/* Left side Login */}
            <div
              className="col-xl-6 p-0 order-lg-1 order-2 flex-center flex-column mt-0"
              style={{
                maxWidth: "26rem",
                minHeight: "33rem",
                background:
                  "linear-gradient(to bottom, #FE5014, #FE5014, #FD9B7B, #FFC6C6)",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <h4 className="text-capitalize text-white p-20 pt-40">
                Shopping with lowest prices & maximum discounts
              </h4>
              <p className="text-white px-20">
                We are connected with wholesalers to offer the best price on
                every item you buy
              </p>
              <img
                className="mt-40"
                src="assets/images/icon/login-img.png"
                alt="LoginImg"
                style={{ objectFit: "cover" }}
              />
            </div>
            {/* Right side Login form */}
            <div
              className="p-24 p-md-5 d-flex justify-content-center flex-column order-lg-2 order-1 border-0"
              style={{ minWidth: "23rem", minHeight: "33rem", width: "100%" }}
            >
              <div className="hover-border-main-600 transition-1 rounded-16 h-100">
                <div className="flex-center flex-column mb-24">
                  <img
                    style={{ width: "10rem" }}
                    src="assets/images/logo/header_logo.png"
                    alt="Logo"
                  />
                  <p className="text-2xl fw-bolder text-black">Welcome Back</p>
                  <p className="text-sm">Log in to access your account</p>
                </div>
                <div className="mb-24">
                  <input
                    type="email"
                    className="common-input"
                    id="email"
                    placeholder="Email Address"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                        message:
                          "Please enter a valid email address (e.g., example@domain.com)",
                      },
                    })}
                  />

                  {errors.email && (
                    <p className="text-xs position-absolute text-danger">
                      {errors.email.message}
                    </p>
                  )}
                </div>
                <div className="mb-24 position-relative">
                  <input
                    style={{ background: "gray" }}
                    type={showPassword ? "text" : "password"}
                    className="common-input"
                    id="password"
                    placeholder="Password"
                    {...register("password", {
                      required: "Password is required",
                    })}
                  />
                  <p
                    className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    <i
                      className={`bi ${
                        showPassword ? "bi-eye-slash" : "bi-eye"
                      }`}
                    ></i>
                  </p>
                  {errors.password && (
                    <p className="position-absolute text-xs text-danger">
                      {errors.password.message}
                    </p>
                  )}
                </div>
                <div className="w-100 text-end">
                  <Link
                    to="/forgotPassword"
                    className="text-xs fw-medium text-muted hover-text-decoration-underline"
                  >
                    Forgot password?
                  </Link>
                </div>
                <div className="my-24 w-100">
                  <button
                    type="submit"
                    className="w-100 btn py-18 px-40 rounded-0 shadow"
                    style={{ background: "#FE5014" }}
                    disabled={!isValid || isLoading}
                  >
                    {isLoading ? <BtnLoader /> : "Login"}
                  </button>
                </div>
                <div className="flex-center w-100">
                  <div className="text-gray-900 border-top border-gray-100 d-block w-90" />
                  <p className="px-4 text-nowrap text-xs">or Login with</p>
                  <div className="text-gray-900 border-top border-gray-100 d-block w-90" />
                </div>
                {/* Google Login Button */}
                <div className="my-24 w-100">
                  <GoogleLogin
                    onSuccess={handleLoginSuccess}
                    onError={handleLoginFailure}
                    scope="email profile https://www.googleapis.com/auth/user.phonenumbers.read"
                  />
                  {user && (
                    <div>
                      <h2>Welcome, {user.name}</h2>
                      <p>Email: {user.email}</p>
                      <p>Phone: {phoneNumber}</p>
                      <p>accessToken: {accessToken}</p>
                    </div>
                  )}
                </div>
                <div className="w-100 flex-center gap-4">
                  <p className="text-xs fw-medium text-muted">
                    Don't have an account?
                  </p>
                  <Link
                    to="/phone-number-verfication"
                    className="text-xs fw-medium text-main text-decoration-underline hover-text-decoration-none"
                  >
                    Signup
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default LoginSection;
